export const MENU_SHOW = 'ui:menu_show';
export const MENU_HIDE = 'ui:menu_hide';
